import {actionTypes} from "./actionTypes";

export const toggleUpdate4DModal=()=>{
    return {
        type:actionTypes.TOGGLE_UPDATE_4D_MODAL,
    }
}